import React from "react";
import { Breadcrumb as AntBreadcrumb } from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./Breadcrumb.module.scss";

interface BreadcrumbItem {
  icon?: React.ReactNode;
  label: string;
  path?: string;
  search?: string;
  isCurrentPage?: boolean;
}

interface CustomBreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const CustomBreadcrumb: React.FC<CustomBreadcrumbProps> = ({ 
  items, 
  className = "" 
}) => {
  const navigate = useNavigate();

  const handleItemClick = (item: BreadcrumbItem) => {
    if (item.path && !item.isCurrentPage) {
      if (item.search) {
        navigate(`${item.path}${item.search}`);
      } else {
        navigate(item.path);
      }
    }
  };

  return (
    <AntBreadcrumb className={`${styles.breadcrumb} ${className}`}>
      {items.map((item, index) => (
        <AntBreadcrumb.Item key={index}>
          {item.isCurrentPage ? (
            <span className={styles.currentPage}>
              {item.icon && <span className={styles.iconWrapper}>{item.icon}</span>}
              <span>{item.label}</span>
            </span>
          ) : (
            <a 
              onClick={() => handleItemClick(item)}
              className={styles.breadcrumbLink}
            >
              {item.icon && <span className={styles.iconWrapper}>{item.icon}</span>}
              <span>{item.label}</span>
            </a>
          )}
        </AntBreadcrumb.Item>
      ))}
    </AntBreadcrumb>
  );
};

export default CustomBreadcrumb;
